export default "__VITE_ASSET__eb5cd1db__"